(function () {
  const sections = document.querySelectorAll('.dyf[data-section-id]');
  if (!sections.length) return;

  const setup = (root) => {
    const video = root.querySelector('.dyf__video');
    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    const tryPlay = async () => {
      try {
        await video.play();
      } catch (e) {}
    };

    if (!('IntersectionObserver' in window)) {
      tryPlay();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    io.observe(root);
  };

  sections.forEach(setup);
})();
